// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"af8f6bb4","518":"ba78d460","569":"8ff2eedb","637":"031be9bf","685":"11c8d920","698":"dedbe2cf","900":"fa804966"}[chunkId] + ".chunk.js";
};